import {
  mdiMessageText,
  mdiBookOpenVariant,
  mdiChartBar,
  mdiBellAlert,
  mdiCog,
  mdiAccountGroup,
  mdiClipboardTextClock,
  mdiHelpCircleOutline,
} from "@mdi/js";

export default [
  {
    to: "/cases",
    icon: mdiMessageText,
    label: "Casos",
  },
  {
    to: "/catalog",
    icon: mdiBookOpenVariant,
    label: "Catálogo",
    roles: ["admin"],
  },
  {
    to: "/unresolved",
    icon: mdiHelpCircleOutline,
    label: "Sin resolver",
    roles: ["admin"],
  },
  {
    to: "/metrics",
    icon: mdiChartBar,
    label: "Métricas",
    roles: ["admin", "agent_l2"],
  },
  {
    to: "/audit",
    icon: mdiClipboardTextClock,
    label: "Auditoría",
    roles: ["admin", "agent_l2"],
  },
  {
    to: "/alerts",
    icon: mdiBellAlert,
    label: "Alertas",
    roles: ["admin", "agent_l2"],
  },
  {
    to: "/settings",
    icon: mdiCog,
    label: "Configuración",
    roles: ["admin"],
  },
  {
    to: "/users",
    icon: mdiAccountGroup,
    label: "Usuarios",
    roles: ["admin"],
  },
];
